<template>
  <section>
    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title">
        Согласование с регионами
      </h1>
      <div class="d-flex flex-row align-start">
        <v-icon
          size="20"
          color="info"
          class="mt-2 mr-2"
        >
          mdi-magnify
        </v-icon>
        <v-text-field
          v-model="search"
          color="info"
          outlined
          label="Начните набирать наименование региона"
          class="search-field"
          dense
          style="min-width: 500px"
        />
      </div>
    </div>
    <wrapper-preview-category>
      <grid-table
        :headers="headers.massive"
        :headers-for-rows="headers.massive"
        :num-cols="headers.countCells"
        :loading-data="loading"
        :data-rows="showingData"
        type-table="grid"
      >
        <template #downloadExcel="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
              class="white__v-btn"
              @click="getSourceTable(row?.id,'Выгрузка Excel по региону.xlsx','\'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\'')"
            >
              Выгрузить
            </v-btn>
          </div>
        </template>
        <template #uploadExcel="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
              class="white__v-btn" @click="openExcelDialog(row)"
            >
              Загрузка Файла
            </v-btn>
          </div>
        </template>
        <template #approvalFile="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
              class="white__v-btn"
              @click="downloadPrint('PrintMinkult', 'downloadinApprovalFile','Файл согласования.pdf','application/pdf', `?regionId=${row?.id}`)"
            >
              Скачать
            </v-btn>
          </div>
        </template>
        <template #uploadScan="{ row }">
          <div class="d-flex flex-column align-end">
            <v-btn
              class="white__v-btn" @click="openScanDialog(row)"
            >
              Загрузка Скана
            </v-btn>
          </div>
        </template>
        <template #status="{ row }">
          <v-icon v-if="row.scan" size="24" color="primary">mdi-check</v-icon>
          <v-icon v-else size="24" color="error">mdi-close</v-icon>
        </template>
      </grid-table>
      <v-dialog v-model="excelDialog" max-width="500">
        <v-card>
          <v-form>
            <v-card-title>
              <h2>Загрузка Файла</h2>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <file-container
                    :num-stage="3" :current-stage="3" :cols="4"
                    :files-config="excelConfig"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog v-model="scanDialog" max-width="800">
        <v-card>
          <v-form>
            <v-card-title>
              <h2>Загрузка Скана</h2>
            </v-card-title>
            <v-card-text>
              <v-row dense>
                <v-col>
                  <file-container
                    :num-stage="3" :current-stage="3" :cols="9"
                    :files-config="scanConfig" :regionID="rowForFile.id"
                    :key="fileKey"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </v-dialog>
    </wrapper-preview-category>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import approvalRegions from "@/helpers/tableConfigs/approvalRegions";
import GridTable from "@/components/GridTable/GridTable";
import {mapActions, mapGetters} from "vuex";
import FileContainer from "@/containers/FileContainer";
import {setFileFunctions} from "@/mixins/fileFucntions";
import RegionController from "@/controllers/OKCP/RegionController";

export default {
  name: "ApprovalRegions",
  components: {GridTable, WrapperPreviewCategory, /*ScanCard,*/ FileContainer},
  mixins: [setFileFunctions],
  data() {
    return {
      search: '',
      headers: approvalRegions,
      loading: false,
      downloadingFileToServer: {regionId: 0, value: false, fileType: null},
      serverData: [],
      regionsWithFiles: [],
      downloadingFile: false,
      excelDialog: false,
      rowForFile: {},
      fileKey: 0,
      // fileKey2: 0,
      scanDialog: false,
      excelConfig: [{
        name: 'Файл Excel',
        types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        typesForChose: ['.xlsx', '.xls'],
        id: null,
        fileType: 'EXCEL_MINKULT'
      }],
      scanConfig: [{
        name: 'Скан',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: null,
        fileType: 'REGION_ACCEPT_MINKULT' // TODO добавить потом ещё Минздрав
      }],
    }
  },
  computed: {
    ...mapGetters('spr', {
      getRegions: 'getRegions',
      getRegionsStatus: 'getRegionsStatus'
    }),
    ...mapGetters('keycloak', {isAdmin: 'isAdmin', isCO: 'isCO'}),
    showingData() {
      return this.regionsWithFiles.filter(el => !this.search || el.name.toLowerCase().search(this.search.toLowerCase()) !== -1)
    },
  },
  created() {
    this.getServerData();
  },
  methods: {
    ...mapActions('spr', {getRegionsFromServer: 'getRegionsFromServer'}),
    
    async getServerData() {
      await RegionController.getRegionsWithScanFilesData().then(data => { // TODO переместить это в vuex
        this.regionsWithFiles = data
      })},
    
    openExcelDialog(row) {
      this.excelDialog = true;
      this.rowForFile = row;
    },
    
    openScanDialog(row) {
      this.scanDialog = true;
      this.rowForFile = row;
      this.fileKey++;
    },
  },
}
</script>

<style scoped>

</style>